
import { Button } from "@/components/ui/button";
import CbLogo from "@/assets/cblogo.png";
import EllipseLogo from "@/assets/EllipseLogo.svg";
import { ThemeToggle } from "@/components/theme-toggle";

function Header() {
    return (
        <header className="relative isolate mx-auto w-full border-b border-slate-200 dark:border-white/10 bg-[#F4F7FB]/80 dark:bg-transparent backdrop-blur overflow-hidden">
            {/* Background glow */}
            <div className="pointer-events-none absolute inset-0 z-0">
                <img src={EllipseLogo} alt="" aria-hidden className="absolute w-130 -left-24 -top-8 blur-2xl opacity-60" />
            </div>

            <div className="relative z-10 mx-auto max-w-6xl px-6 py-5 flex items-center justify-between gap-8">
                <a href="#" aria-label="CodeBoost — voltar ao topo">
                    <img src={CbLogo} alt="CodeBoost" className="h-10 w-auto" />
                </a>

                <nav className="flex items-center gap-6 text-base font-medium">
                    <a className="text-cyan-600 dark:text-cyan-400 transition-colors hover:text-cyan-700 dark:hover:text-cyan-300" href="#">
                        Home
                    </a>
                    <a className="text-slate-600 dark:text-slate-200/80 transition-colors hover:text-cyan-600 dark:hover:text-cyan-300" href="#sobre-nos">
                        Sobre Nós
                    </a>
                    <a className="text-slate-600 dark:text-slate-200/80 transition-colors hover:text-cyan-600 dark:hover:text-cyan-300" href="#beneficios">
                        Benefícios
                    </a>
                    <a className="text-slate-600 dark:text-slate-200/80 transition-colors hover:text-cyan-600 dark:hover:text-cyan-300" href="#cases">
                        Cases
                    </a>
                    <ThemeToggle />
                    <a href="#contato">
                        <Button className="bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-950 font-semibold px-5 py-2 text-sm shadow-[0_0_20px_rgba(56,189,248,0.2)] hover:shadow-[0_0_30px_rgba(56,189,248,0.35)] transition-all cursor-pointer">
                            Contato
                        </Button>
                    </a>
                </nav>
            </div>
        </header>
    );
}

export default Header;
